import ReactGA from 'react-ga4';
import invariant from 'tiny-invariant';
import * as z from 'zod';

const GACustomEventSchema = z.strictObject({
  eventName: z.string(),
  eventParams: z.any(),
});

export function logCustomEvent(eventName, eventParams) {
  const safeParseResult = GACustomEventSchema.safeParse({
    eventName,
    eventParams,
  });
  if (safeParseResult.success) {
    const { data } = safeParseResult;
    try {
      ReactGA.event(data.eventName, data.eventParams);
    } catch (e) {
      console.error('failed to log ga event', data);
    }
  } else {
    console.warn('Failed to log GA Event data', safeParseResult.error);
  }
}

export default function logEvent(
  category,
  action,
  label,
  value,
  callback = null,
  timeout = 2000,
) {
  const re = / |-/gi;
  // Send a custom event
  ReactGA.event({
    category: category.replace(re, '_').toLowerCase(),
    action: action.replace(re, '_').toLowerCase(),
    label: label,
    value: value,
  });

  if (callback) {
    callback();
  }
  return;
}

export function logCTEventsToGA(events) {
  invariant(events && events.length > 0);
  //loop through events and map ct event data to GA data
  events.forEach((e) => {
    logCustomEvent(e.data.type, e.data);
  });
}
